import React = require('react');

import ErrorIcon from "material-ui/svg-icons/alert/error";
import WarningIcon from "material-ui/svg-icons/alert/warning";
import SuccessIcon from "material-ui/svg-icons/navigation/check";

export const DialogStatusError = "error";
export const DialogStatusSuccess = "success";
export const DialogStatusWarning = "warning";

interface StatusViewProps extends React.Props<StatusView> {
    title?: string;
    status: string;
    style?: React.CSSProperties;
}

export default class StatusView extends React.Component<StatusViewProps, {}> {

    render() {
        let icon: JSX.Element;
        let cssClass = "dialog-body dialog-" + this.props.status;

        switch (this.props.status) {
            case DialogStatusSuccess:
                icon = <SuccessIcon color="#4ccd1a" />;
                break;

            case DialogStatusWarning:
                icon = <WarningIcon color="#949494" />;
                break;

            case DialogStatusError:
            default:
                icon = <ErrorIcon color="#ff0000" />;
                break;
        }

        return (
            <div className={cssClass} style={this.props.style}>
                <div className="dialog-icon">
                    {icon}
                </div>

                {this.props.title
                    ? <h3 className="dialog-title">{this.props.title}</h3>
                    : ""}

                <div className="dialog-description">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/info-dialog/views/StatusView.tsx
 **/